import Decimal from "decimal.js";
// Utility functions using Decimal.js for safer mathematical operations than vanilla JS.
// It provides precision and avoids the typical floating-point issues.

export const roundNumber = (number: number, decimalPlaces = 2): number => {
  return new Decimal(number).toDecimalPlaces(decimalPlaces, Decimal.ROUND_DOWN).toNumber();
};

export const addNumbers = (numberOne: number, numberTwo: number): number => {
  return new Decimal(numberOne).add(new Decimal(numberTwo)).toNumber();
};

export const subtractNumbers = (numberOne: number, numberTwo: number): number => {
  return new Decimal(numberOne).sub(new Decimal(numberTwo)).toNumber();
};

export const divideNumbers = (numberOne: number, numberTwo: number): number => {
  return new Decimal(numberOne).div(new Decimal(numberTwo)).toNumber();
};

export const multiplyNumbers = (numberOne: number, numberTwo: number): number => {
  return new Decimal(numberOne).mul(new Decimal(numberTwo)).toNumber();
};

export const countDecimalPlaces = (number: number): number => {
  // Convert the number to a string
  const numberString = number.toString();

  // Use regular expression to find decimal places
  const match = numberString.match(/\.(\d+)/);

  // If there are decimal places, return the count, otherwise return 0
  return match ? match[1].length : 0;
};

export const sumArray = (array: number[]) => {
  let total = 0;
  for (const num of array) {
    total = addNumbers(total, num);
  }

  return total;
};
